import AuthView from './View';

export default AuthView;